export default __webpack_public_path__ + "static/media/rusgot-mobile-3.91ecd73f.png";